import React from 'react'

import logo from './resources/logo.svg'
import service1 from './resources/service-1.svg'
import service2 from './resources/service-2.svg'
import service3 from './resources/service-3.svg'
import service4 from './resources/service-4.svg'
import llc1 from './resources/why-llc-1.svg'
import llc2 from './resources/why-llc-2.svg'
import llc3 from './resources/why-llc-3.png'
import back from './resources/back.svg'
import left from './resources/left.svg'
import right from './resources/right.svg'

export type SvgName =
  | 'logo'
  | 'service1'
  | 'service2'
  | 'service3'
  | 'service4'
  | 'llc1'
  | 'llc2'
  | 'llc3'
  | 'back'
  | 'left'
  | 'right'

const icons = {
  logo,
  service1,
  service2,
  service3,
  service4,
  llc1,
  llc2,
  llc3,
  back,
  left,
  right,
}

interface Props {
  name: SvgName
}

export default function Svg({ name, ...props }: Props) {
  return <img {...props} src={icons[name]} alt={name} />
}
